
import axios from "axios";
import { gerar_token, somenteNumeros } from './DSi_basico'

var URL_DSI = sessionStorage['url']



 export async function status_whats(){

    

    let config_whats = JSON.parse(sessionStorage['config_whats'])
    // console.log('config_whats:', config_whats);

    if (!config_whats){
      console.log('WhatsApp não configurado!')
      return false
    }


    let ide      = sessionStorage['lg:IDE']
    let token    = parseInt(ide * 777888999)
    let api_url  = config_whats.API_LINK
    api_url      = api_url?.replaceAll('@token', token) //removo caracter especial
    api_url      = api_url?.replaceAll('send-messages','status') //removo caracter especial
    
    let api_qr   = api_url?.replaceAll('/send-messages','') //removo caracter especial

    // console.log('api_url:', api_url)



    let retorno = ''
    try {

        const data = {
          url:  api_url,
        }  
        // console.log('data:' , data);
        // const header =   {}
        const header =   { headers: {'Content-Type': 'application/json'}}//TEM QUE USAR O json_decode NO PHP que vai receber


        const res = await axios.post(URL_DSI+'scapeCors.php', data, header);

        retorno = JSON.parse(res.data);
        // console.log('retorno:', retorno);
        return  retorno

      // res = await axios.get(url, header) //ORIGINAL ZAPI
    } catch (err) {
        // Handle error
        // console.log('status_zap: ', err);
        // this.zap_message = err.message
        // o programa pode nao estar rodando la no servidor
        // this.zap_message = 'Atualizando Servidor, tente novamente mais tarde'
        console.log('ERRO:', err.message);
        // return err.message
        return {connected: false, error: `Atualizando Servidor, tente novamente mais tarde: ${err.message}`}
    }

 };


 export async function send_whats_api(tipo, celular, texto, file){


    if (!celular){
        return false
    }
    celular =  await somenteNumeros(celular)


    let url = meu_url()+`clientes/envia_whats.php`

    let config_whats = JSON.parse(sessionStorage['config_whats'])
    // console.log('config_whats:', config_whats);

    let ide = sessionStorage['lg:IDE']
    let token = parseInt(ide * 777888999)
    let api_url = config_whats.API_LINK
    api_url       = api_url?.replaceAll('@token', token) //removo caracter especial
    

    
    let ID_DSI = await gerar_token(ide)

    const data = {
                            
        acao            : 'ENVIA_SIMPLES',
        api_url         : api_url,
        tipo            : tipo,
        id_cliente      : ide, 
        empresa         : sessionStorage['lg:EMPRESA'], 
        id_dsi          : ID_DSI, 
        usuario         : sessionStorage['lg:USUARIO'], 
        celular         : celular, 
        msg             : texto, 
        file            : file 
        // optionList      : optionList, 
    }  

    // console.log(data);
    const header = { headers: {'Content-Type': 'application/x-www-form-urlencoded'}}//so funciona com isso daqui
    const res    = await axios.post(url, data, header);//envia 
    let retorno  = (res.data);
    // console.log('retorno:', retorno);
    return retorno

 }; 



 export async function send_whats_api_45(tipo, origem, empresa, celular, msg, dia, hora, file){

    celular = celular.replace(/\D/gim, '');//somente numeros


    if ((!celular)||(!msg)){
    return 'exit-celular ou msg não definidos'
    }

    // let url     = `http://localhost/vue_cfc/public/clientes/envia_whats.php`
    let url     = `https://dsi.app.br/f/c/clientes/envia_whats.php`
    let api_url = "http://dsi.app.br:8051/35005004955/send-messages"
    
    let ID_DSI = await gerar_token(45)


    const data = {
                    
        acao            : 'ENVIA_SIMPLES',
        tipo            : tipo,
        api_url         : api_url,
        id_cliente      : '45', 
        empresa         : empresa, 
        id_dsi          : ID_DSI, 
        usuario         : origem, 
        celular         : celular, 
        msg             : msg,
        data            : dia,
        hora            : hora,
        file            : file 
    } 


    // console.log(data);
    const header = { headers: {'Content-Type': 'application/x-www-form-urlencoded'}}//so funciona com isso daqui
    const res    = await axios.post(url, data, header);//envia 
    let retorno  = (res.data);

    // console.log('envia_simples_whats:', retorno);
    // let retorno_obj = JSON.parse(retorno);

    return retorno

 };


 export async function enviar_email_45(para, assunto, texto){
    // console.log('enviar_email:');

    let link = "https://dsi.app.br/f/c/email.php"

    const data = {
              
              para:      para,
              assunto:   assunto, 
              texto:     texto,
    }  

    // alert(link)
    // console.log(data);
    const header =   { headers: {'Content-Type': 'multipart/form-data'}}

    const res = await axios.post(link, data, header);
    // console.log('enviar_email_45:', res.data);
    return res.data

 };



  function meu_url(){
          
    let url = ''

    if (sessionStorage['url'] == '/api/'){
      url =  `http://localhost/vue_cfc/public/`
    }
    else{
      url =  `https://dsi.app.br/f/c/`
    }

    return url
 };